import React,{useEffect,useState} from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStar, faHospital } from '@fortawesome/free-solid-svg-icons';
import axios from 'axios'
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { useNavigate } from 'react-router-dom';
// import { Calendar, DateObject } from 'react-multi-date-picker';
import DatePicker, { Calendar } from "react-multi-date-picker";
import persian from 'react-date-object/calendars/persian';
import persian_fa from 'react-date-object/locales/persian_fa';
import { ToastContainer, toast } from "react-toastify";
import moment from "jalali-moment";

export const NobatOnline = () => {
    
    const [list,setList] = useState([])
    const navigate =useNavigate()

useEffect(() => {
 const getAllLietDoctor = async() => {
        const res = await fetch(
            'https://clinic.salamatpayanew.ir/getAllDocotorList'
          );
        setList(await res.json());
 }
    getAllLietDoctor()
},[])

const [listTime,setListTime] = useState([])

/* useEffect(() => {
const getAllLietDoctor = async() => {
  const res = await fetch(
        `https://clinic.salamatpayanew.ir/getTimeAll/${docotorNezam}`
   );
      setListTime(await res.json());
      getAllLietDoctor()
}
},[]) */

const [showb, setShowb] = useState(false);
const handleCloseb = () => setShowb(false);
const handleShowb = () => setShowb(true);

const [showbR, setShowbR] = useState(false);
const handleClosebR = () => setShowbR(false);
const handleShowbR = () => setShowbR(true);

const [hor,setHor] = useState('')
const [date,setDate] = useState('')
const [nezam,setNezam] = useState('')
const [tel,setTel] = useState('')
const [token,settokenID] = useState('')
const [day,setDay] = useState('')

const handelShoeNobat = (id,ttm,ddm,nezm,ttko,dday) => {
  setHor(ttm)
  setDate(ddm)
  setNezam(nezm)
  settokenID(ttko)
  setDay(dday)
  handleShowbR(true)
  handleCloseb(true)
}

const [docotorName,setDoctorname] = useState('')
const [docotorNezam,setDoctorNezam] = useState('')
const [selectedDate, setSelectedDate] = useState(new Date());

const [tokenIDR, settokenIDR] = useState("");

useEffect(() => {
  settokenIDR(Math.floor(Math.random() * 9652805) + 15);
 }, []);

/* useEffect(() => {
  const filterDate = async() => {
      await axios.get(`https://clinic.salamatpayanew.ir/admin/filterdate/${selectedDate}`)
      const res = await fetch(
        `https://clinic.salamatpayanew.ir/admin/filterdate/${selectedDate}`
   );
      setListTime(await res.json());
  }
  filterDate()
}) */

const today = new Date();
const dateem = moment(new Date(), "YYYY-MM-DD").locale("fa").format("YYYY-MM-DD");

const handelShowPop = async(nameDocotr,nezamDoctor) => {
  try{
    setDoctorname(nameDocotr)
    setDoctorNezam(nezamDoctor)
    const res = await fetch(
      `https://clinic.salamatpayanew.ir/getTimeAll/${nezamDoctor}&${dateem}`
 );
    setListTime(await res.json());
    handleShowb(true)
  }catch(err){
    toast.warning("تاریخ به درستی انتخاب نشده است")
  }
}

const [ico,setIco] = useState('')

const handelNumber = async() => {
try{
  settokenIDR(Math.floor(Math.random() * 5634563) + 12);
 await axios.post("https://clinic.salamatpayanew.ir/admin/regTimes",{
    tel:tel,     
    date:date,
    times:hor,
    stat:'1',
    token:token,
    nezam:nezam,
    day:day,
    tokenIDR:tokenIDR,
    ico:ico
 }).then(() => {
        toast.success("نوبت شما ثبت شد کد پیگیری خود را در مطب به همراه داشته باشید." + tokenIDR)         
        handleClosebR(true)
 }).catch(() =>{
        toast.error("شما در این  تاریخ یک نویت ثبت شده دارید")
 })

 await axios.put(`https://clinic.salamatpayanew.ir/admin/updateAllDate/${hor}&${date}&${token}`,{
    stat:'2'
 });

}catch(err){
  toast.error("خطا در ثبت")
}
   /* await axios.post("https://rest.payamak-panel.com/api/SendSMS/SendSMS",{
    username:'mtcmtc',
    password:'d3eamg',
    to:'09035936462',
    from:'30001220512012',
    text:'سلام تست',
   }) */

}

return (
<>
 <section>
   <div className="main_wrap">
    <img
      className="d-block w-100"
      src={'/img/slide1.jpg'}
      alt="Slide 1"
      />
      <br />
 <div className="container">
    {
     list.map((item) =>{
        const {id,nezam,name} = item
     return(
    <li className="card p-3 shadow rounded-3">
      <div className="row text-lg-right text-center">
        <div className="col-lg-2 text-lg-left text-center align-self-center">
          <img
            src={item.img}
            className="p_relative border rounded-circle"
            height={'10px'}
            width={'80px'}
            alt="Doctor"
          />
        </div>
        <div className="col-lg-8 text-right">
          <h4 className={'font-weight-bold'} style={{ color: 'rgb(6,80,122' }}>
           <p>{item.name}</p>
          </h4>
          <p style={{color:'blue'}}>کد نظام پزشکی : {item.nezam}</p>
          <p className="mb-3">
            <FontAwesomeIcon icon={faHospital} className="pl-1" />
            {item.exp}
          </p>
        </div>
        <div className="col-lg-2 align-self-center">
          <button onClick={e => handelShowPop(name,nezam)}
            className="btn btn-success IRANSans_Medium py-2 btn-block">
              ثبت نوبت آنلاین
          </button>
        </div>
      </div>
    </li>
        )
    })
 }
    </div> 
    <br />
</div>
 </section>

 <Modal
    show={showb}
    onHide={handleCloseb}
    size="lg"
    aria-labelledby="contained-modal-title-vcenter"
    centered>
    <Modal.Body>
        <div className="row">
            <div className="col-md-12">
            <div className="row">
            {listTime.map((houre, index) => (
                 <div className="col-sm-2" key={index}>

                    {houre.stat === '1' ? (
                      <button onClick={(e) => handelShoeNobat(houre.id,houre.db,houre.dateRF1,houre.nezam,houre.token,houre.day)}
                        id="btn-1"
                        type="button"
                        className="btn btn-warning mt-3">
                        {houre.day}   {houre.db} 
                      </button>
                    ):(
                      <button
                        id="btn-1"
                        type="button"
                        disabled
                        className="btn btn-dark mt-3">
                        {houre.day}   {houre.db} 
                      </button>
                    )
              }
                    </div>
              ))
               }
            </div>
          </div>
        </div>
    </Modal.Body>
 </Modal>

 <Modal
    show={showbR}
    onHide={handleClosebR}
    aria-labelledby="contained-modal-title-vcenter"
    centered>
        <Modal.Body>
        <h5>شماره همراه خود را وارد نمائید</h5>
        <hr />
      <span style={{color:'red'}}>تاریخ نوبت : {date}  ساعت نوبت : {hor}</span>
      <hr/>
      <select className='form-control' onChange={(e) => setIco(e.target.value)}>
        <option value={'نیستم'}>انتخاب کنید</option>
        <option value={'هستم'}>مراجعه به این پزشک داشتم</option>
        <option value={'نیستم'}>مراجعه برای اولین بار</option>
      </select>
        <hr />
           <input type='text' className='form-control' maxLength={11} placeholder='شماره همراه را وارد نمائید' onChange={(e) => setTel(e.target.value)} />
           <br />
           <div style={{textAlign:'center'}}><button className='btn btn-dark' onClick={handelNumber}>تایید شماره همراه</button></div>
        </Modal.Body>
 </Modal>

 <ToastContainer
        position="top-center"
        autoClose={80000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />

</>

  );
};
